export default __webpack_public_path__ + "static/media/contact.801bb9dc.svg";